// All Swedish content for Redoc AML & KYC landing pages.
// Verbatim from source document, lightly cleaned for display.

export const brand = {
  name: "Redoc AML & KYC",
  short: "Redoc",
  tagline:
    "Allmän riskbedömning & Kundkännedom – för redovisningsbyråer som vill arbeta enkelt, strukturerat och tryggt.",
};

export const hero = {
  eyebrow: "Webbaserad tjänst för redovisningsbyråer",
  title:
    "Upprätta kundkännedom, riskanalyser och allmän riskbedömning – på ett ställe.",
  subtitle:
    "Med Redoc AML & KYC upprättar Du kundkännedom (KYC), riskanalyser för tjänster och allmän riskbedömning för byrån. En webbaserad tjänst som hjälper redovisningsbyråer att uppfylla kraven i Penningtvättlagen – enkelt, strukturerat och tryggt.",
  primaryCta: "Boka demo",
  secondaryCta: "Begär mer information",
};

export const intro = {
  paragraph:
    "För en redovisningsbyrå handlar det inte bara om att uppfylla lagkraven, utan också om att skapa effektiva och trygga rutiner som håller över tid. Med Redoc AML & KYC kvalitetssäkrar Du även redovisningsuppdragen och får kontroll över byråns kunder och uppdrag på ett tryggt och effektivt sätt.",
};

export const reasons = [
  {
    title: "Allmän riskbedömning",
    body: "En strukturerad genomgång av byråns risker.",
  },
  {
    title: "Kundkännedom (KYC)",
    body: "Smidiga processer för att identifiera och förstå era kunder.",
  },
  {
    title: "Löpande kontroll",
    body: "Trygg förvaring och uppföljning som följer gällande regelverk.",
  },
  {
    title: "Enklare att visa efterlevnad",
    body: "När frågor eller granskning kommer.",
  },
  {
    title: "Checklistor för redovisningsuppdragen",
    body: "Med integrerad övervakning av riskfaktorer.",
  },
  {
    title: "Säker och trygg lagring",
    body: "Lagring på servrar i Sverige med backup och övervakning.",
  },
];

export const pillars = [
  {
    title: "Lättanvänt",
    body: "Lika enkelt att använda på datorn som på mobilen.",
  },
  {
    title: "Obegränsat",
    body: "Obegränsat antal kunder, användare och kontor.",
  },
  {
    title: "Anpassningsbart",
    body: "Anpassningsbara rättigheter för användare, avdelningar och kontor.",
  },
  {
    title: "Regelbaserat",
    body: "Hjälper Dig att uppfylla kraven för Penningtvättlagen och kvalitetssäkrad redovisning enligt branschkraven för auktoriserade redovisningskonsulter.",
  },
];

export const featureModules = [
  {
    heading: "För hantering av kunderna",
    items: [
      "Kundregister",
      "Uppdrags- och momentansvar",
      "Status upprättade uppdragsavtal",
      "Riskanalys för ny kund",
      "Kundkännedom (KYC)",
      "Årlig genomgång av kundkännedom (KYC)",
      "Upprätta uppdragsavtal",
      "Årsplanering",
      "Företags- och uppdragsbeskrivning",
      "Fullmaktsregister för kunder",
      "Årlig omprövning av kund",
      "Avslut av uppdrag",
      "Register och status kundmaterial",
      'Ärendehantering & "To-Do"',
    ],
  },
  {
    heading: "För hantering av uppdragen",
    items: [
      "Checklista redovisningsuppdrag",
      "Checklista löneuppdrag & AGI",
      "Checklista bokslut & årsredovisning",
      "Checklista momsdeklaration",
      "Checklista periodisk sammanställning",
      "Checklista betalningsuppdrag",
      "Checklista inkomstdeklaration & K10",
      "Checklista kontrolluppgifter",
    ],
  },
  {
    heading: "För byråns interna rutiner",
    items: [
      "Personalregister",
      "Utbildningsregister",
      "Utbildningsplanering",
      "Checklista & status byrådokument",
      "Allmän riskbedömning byrån (PTL)",
      "Intern kvalitetskontroll",
      "Analys riskhantering",
      "Kontor",
    ],
  },
];

export const featuresIntro =
  'Ovanstående är de checklistor som ingår som gör att man enkelt skapar den dokumentation på kund- och uppdragsnivå som krävs för att uppfylla de kvalitetskrav som gäller för auktoriserade redovisningskonsulter. Redoc AML & KYC är skapat utifrån de "skall"-krav som ställs i de regelverk som man måste följa som auktoriserad redovisningskonsult. Med Redoc går det snabbt och effektivt att upprätta den dokumentation som krävs för att uppfylla Penningtvättlagens krav både på kund- och byrånivå.';

export const deepDive = [
  {
    title: "Kundkännedom (KYC)",
    body:
      "I Redoc AML & KYC ingår funktion för att hjälpa Dig att smidigt upprätta en gedigen kundkännedom och riskanalys av kunden för att uppfylla kraven enligt Penningtvättlagen. Med Redoc KYC får Du en tydlig överblick över byråns alla upprättade kundkännedomsanalyser med aktuell status och gör det enkelt för Dig att se när det måste göras den årliga översynen av kundkännedomsanalysen. Med Redoc KYC-funktionen kan Du upprätta kundkännedomsanalyser för obegränsat antal klienter på byrån.",
  },
  {
    title: "Allmän riskbedömning (PTL)",
    body:
      'Med Redoc AML & KYC upprättar du utförliga riskanalyser med slutsatser och ställningstaganden för de tjänster som din byrå erbjuder och sammantagen "Allmän riskbedömning" för byrån. Att upprätta en "Allmän riskbedömning" enligt Penningtvättlagen är avgörande för att säkerställa att Din byrå arbetar efter och uppfyller kraven enligt Penningtvättlagen och därmed minimerar risken för att utnyttjas för penningtvätt och finansiering av terrorism. Redoc AML hjälper Dig med de rätta frågeställningarna som gör att Du får en grundlig analys och bedömning av samtliga riskfaktorer som anges i Penningtvättlagen, med en motiverad bedömning av riskfaktorerna var för sig samt ställningstagande till hur stor risken blir för att kunna utnyttjas för penningtvätt och finansiering av terrorism.',
  },
  {
    title: "Riskanalys tjänster",
    body:
      "Med Redoc AML & KYC skapar Du separata analyser/riskbedömningar av de tjänster som företaget erbjuder med analys av geografiska riskfaktorer och distributionskanaler för varje tjänst. I Redoc AML kan Du även upprätta separata analyser/riskbedömningar utifrån företagets definierade kundkategorier och även branscher.",
  },
  {
    title: "Analys riskhanteringsmetoder",
    body:
      'Med funktionen "Analys riskhanteringsmetoder" analyserar och bedömer du hur väl byråns riskhanteringsmetoder fungerar. Enligt Penningtvättlagen skall intern kontroll utföras vilket innebär att bedömning skall göras av befintliga kontrollåtgärder och övervakningssystem för att säkerställa deras effektivitet och förmåga att upptäcka och förhindra oegentligheter. I denna analys ingår funktioner för att utse en ansvarig för de riskhanteringsfunktioner som behöver åtgärdas och dokumentation av genomförda åtgärder med datum när åtgärden är avslutad.',
  },
  {
    title: "Riskanalys ny kund",
    body:
      'Med funktionen "Riskanalys ny kund" upprättar Du snabbt och enkelt en gedigen riskanalys för att avgöra om kunden uppfyller byråns krav för att kunna antas som kund på byrån. Denna riskanalys för ny kund är en uppdatering med nya frågeställningar för att fånga upp risker kopplade till Penningtvättlagen och med nya riskfrågor från Ekobrottsmyndigheten.',
  },
  {
    title: "Årlig omprövning",
    body:
      'Med funktionen "Årlig omprövning" upprättar Du snabbt och enkelt den årliga omprövningen för att kunna avgöra om samarbetet har fungerat bra under året och att kunden uppfyller byråns krav och riktlinjer för att kunna vara kund på byrån.',
  },
];

export const lagkrav = {
  title: 'Grundläggande krav som Penningtvättlagen ställer på en "Allmän riskbedömning"',
  items: [
    {
      title: "Verksamhetsanalys",
      body: "En grundlig genomgång av din verksamhet och dess struktur för att identifiera och förstå potentiella risker för penningtvätt och finansiering av terrorism.",
    },
    {
      title: "Lands- och regionanalys",
      body: "Utvärdering av riskerna i de geografiska områden där din verksamhet är verksam, med hänsyn till internationella sanktioner och bedömda riskfaktorer.",
    },
    {
      title: "Kundanalys",
      body: "Analys och utvärdering av kundkategorier, kundrelationer, branscher och transaktionsmönster för att upptäcka ovanliga eller misstänkta aktiviteter.",
    },
    {
      title: "Intern kontroll",
      body: "Bedömning av befintliga kontrollåtgärder och övervakningssystem för att säkerställa deras effektivitet och förmåga att upptäcka och förhindra oegentligheter.",
    },
    {
      title: "Tjänsteanalys",
      body: "Bedömning av de olika produkter och tjänster som erbjuds för att fastställa hur de kan påverka risken för penningtvätt och finansiering av terrorism.",
    },
    {
      title: "Utbildning",
      body: "Säkerställande av att personalen är utbildad och medveten om riskerna för penningtvätt och finansiering av terrorism och fastställda rutiner.",
    },
  ],
};

export const services = {
  title: "Tjänster som vi tillhandahåller",
  items: [
    {
      title: "Intern kvalitetssäkring",
      body: "Vi hjälper Er med utveckling och support för Er interna kvalitetssäkring. I denna tjänst ingår bland annat att vi hjälper Er med att ta fram eller utveckla Er policy för kvalitetssäkring och byrårutiner. Genomgång av befintlig kvalitetspolicy, analys och förslag på förbättringar.",
    },
    {
      title: "Intern kvalitetskontroll",
      body: "Vi kan utföra intern kvalitetskontroll av Era redovisningskonsulter för att säkerställa att konsulterna uppfyller kvalitetskraven för en auktoriserad redovisningskonsult. Ni kan till exempel göra egna kvalitetskontroller med hjälp av rutinen för kvalitetskontroll i Redoc AML & KYC av några konsulter och uppdrag varje år och sedan gör vi en kvalitetskontroll på några (2–3) uppdrag vart annat eller vart tredje år för att säkerställa tidigare resultat i kvalitetskontrollerna, vilket avslutas med en rapport över resultat och förbättringsåtgärder.",
    },
    {
      title: "Rådgivning Penningtvättlagen",
      body: "Vi kan tillhandahålla konsultationer och rådgivning avseende rutiner och dokumentation avseende Penningtvättslagen.",
    },
    {
      title: "Utbildning i Penningtvättlagen",
      body: 'Kan nu även erbjuda webkursen "Introduktion till Penningtvättslagen för redovisningsbyråer" som är utvecklad speciellt för redovisningsbyråer. Detta är en självstudiekurs via vår e-learning portal. Det är obligatoriskt enligt Penningtvättlagen att varje år tillhandahålla personalen utbildning inom området penningtvätt.',
    },
  ],
};

export const mallar = {
  title: "Mallar och rutiner",
  items: [
    {
      title: "Exempelmallar i Redoc KYC & AML",
      body: "Exempelmallar installerade i Redoc AML & KYC för riskanalyser av tjänsterna: löpande redovisning, löner, bokslut, inkomstdeklaration samt exempelmall för sammantagen riskbedömning för byrån. Exempelmallar för upprättad kundkännedom (KYC) avseende en lokal kund och en distanskund.",
    },
    {
      title: "Mall för byråns rutiner enligt Penningtvättlagen",
      body: 'Mall för "Byråns rutiner avseende åtgärder enligt Penningtvättlagen" som är utvecklad och helt anpassad för användning tillsammans med Redoc AML & KYC.',
    },
  ],
};

export const navLinks = [
  { id: "funktioner", label: "Funktioner" },
  { id: "kyc", label: "KYC & Riskbedömning" },
  { id: "lagkrav", label: "Lagkrav" },
  { id: "tjanster", label: "Tjänster" },
  { id: "kontakt", label: "Kontakt" },
];

export const footer = {
  brand: "Redoc AML & KYC",
  copy: "© 2026 Redoc TM Aktiebolag",
  description:
    "Webbaserad tjänst för redovisningsbyråer – Allmän riskbedömning, Kundkännedom och kvalitetssäkring enligt Penningtvättlagen.",
};
